<template>
  <b-card no-body class="card-shadow mb-3">
    <b-card-header class="d-flex justify-content-between align-items-center">
      <span>
        <i class="fas fa-list mr-2"></i>
        Scanned Devices
        <b-badge variant="secondary" class="ml-1">{{ remaining.length }} remaining</b-badge>
      </span>
      <div class="d-flex" style="gap:8px;">
        <base-button size="sm" type="outline-secondary" @click="toggleSelectAll">
          {{ allSelected ? 'Deselect all' : 'Select all' }}
        </base-button>
        <base-button size="sm" type="primary" :disabled="selected.length === 0" @click="openForm">
          <i class="fas fa-tasks mr-1"></i> Assign {{ selected.length > 0 ? selected.length : '' }} selected
        </base-button>
      </div>
    </b-card-header>

    <b-card-body class="p-0">
      <b-list-group flush>
        <b-list-group-item
          v-for="mac in remaining"
          :key="mac"
          class="d-flex justify-content-between align-items-center"
          :style="isSelected(mac) ? '' : 'opacity:0.4'"
          style="cursor:pointer;"
          @click="toggleMac(mac)"
        >
          <div class="d-flex align-items-center" style="gap:10px;">
            <b-form-checkbox
              :checked="isSelected(mac)"
              @change="toggleMac(mac)"
              @click.native.stop
            />
            <span class="font-monospace">{{ mac }}</span>
          </div>
          <base-button
            size="sm" type="outline-danger"
            @click.native.stop="removeMac(mac)"
          >
            <i class="fas fa-times"></i>
          </base-button>
        </b-list-group-item>
      </b-list-group>
    </b-card-body>

    <b-card-footer class="d-flex justify-content-between align-items-center py-2">
      <small class="text-muted">
        {{ selected.length }} of {{ remaining.length }} selected
      </small>
      <base-button size="sm" type="outline-danger" @click="$emit('cleared')">
        <i class="fas fa-trash mr-1"></i> Clear all
      </base-button>
    </b-card-footer>

    <DeviceFormModal
      :show="showForm"
      mode="add"
      :batch-macs="selected"
      @close="showForm = false"
      @saved="onSaved"
    />
  </b-card>
</template>

<script>
import DeviceFormModal from '@/components/DeviceFormModal.vue'

export default {
  name: 'BulkAssignManager',
  components: { DeviceFormModal },
  props: {
    macs: { type: Array, required: true }
  },
  data() {
    return {
      remaining: [],
      selected: [],
      showForm: false
    }
  },
  computed: {
    allSelected() {
      return this.remaining.length > 0 && this.selected.length === this.remaining.length
    }
  },
  watch: {
    macs: {
      immediate: true,
      handler(val) {
        // Merge new MACs in without wiping selection state
        const incoming = val.filter(m => !this.remaining.includes(m))
        this.remaining = [...this.remaining, ...incoming]
        // Auto-select newly arriving MACs
        this.selected = [...new Set([...this.selected, ...incoming])]
      }
    }
  },
  methods: {
    isSelected(mac) {
      return this.selected.includes(mac)
    },
    toggleMac(mac) {
      const idx = this.selected.indexOf(mac)
      if (idx === -1) this.selected.push(mac)
      else this.selected.splice(idx, 1)
    },
    toggleSelectAll() {
      this.selected = this.allSelected ? [] : [...this.remaining]
    },
    removeMac(mac) {
      this.remaining = this.remaining.filter(m => m !== mac)
      this.selected = this.selected.filter(m => m !== mac)
    },
    openForm() {
      if (this.selected.length === 0) return
      this.showForm = true
    },
    onSaved() {
      const justAssigned = [...this.selected]
      this.remaining = this.remaining.filter(m => !justAssigned.includes(m))
      this.selected = [...this.remaining] // auto-select what's left
      this.showForm = false
      this.$emit('assigned', justAssigned)
      if (this.remaining.length === 0) this.$emit('cleared')
    }
  }
}
</script>